import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export const createValeAlimentacaoSchema = zod.ValeAlimentacaoSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export type CreateValeAlimentacaoInput = z.infer<
    typeof createValeAlimentacaoSchema
>

export const updateValeAlimentacaoSchema = zod.ValeAlimentacaoSchema.omit({
    createdAt: true,
    updatedAt: true,
})
    .partial()
    .required({ id: true })

export type UpdateValeAlimentacaoInput = z.infer<
    typeof updateValeAlimentacaoSchema
>

export type ValeAlimentacao = z.infer<typeof zod.ValeAlimentacaoSchema>

export const ValoresValeAlimentacaoSchema = z.object({
    funcionarioId: z.number().int(),
    competencia: z.string(),
    valorTotal: z.number(),
    porcentagemReceber: z.number(),
    data: z.date(),
    horasTrabalhadas: z.number().or(z.string()),
})

export type ValoresValeAlimentacao = z.infer<
    typeof ValoresValeAlimentacaoSchema
>

export const valeAlimentacao = new ApiService<
    CreateValeAlimentacaoInput,
    ValeAlimentacao
>('vale-alimentacao')

export const valoresValeAlimentacao = new ApiService<ValoresValeAlimentacao>(
    'vale-alimentacao/list',
)
